module.exports = "<pre><code class=\"lang-js\">import { VStepper } from &#39;vue-stepper-component&#39;\n\nexport default {\n  components: {\n    VStepper\n  },\n  data: () =&gt; ({ steps: 3, step: undefined })\n}\n</code></pre>\n";


//////////////////
// WEBPACK FOOTER
// ./src/markdowns/examples/default/script.md
// module id = LDf2
// module chunks = 1